<div class="ss-loading" *ngIf="loading">
  <div class="ss-spinner"></div> Loading…
</div>

<div class="dashboard-page" *ngIf="!loading">

  <!-- Stat cards -->
  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-label">Total Batches</div>
      <div class="stat-value">{{ batches.length }}</div>
    </div>
    <div class="stat-card warning">
      <div class="stat-label">Pending</div>
      <div class="stat-value">{{ countByStatus('Pending') }}</div>
    </div>
    <div class="stat-card accent">
      <div class="stat-label">In Progress</div>
      <div class="stat-value">{{ countByStatus('InProgress') }}</div>
    </div>
    <div class="stat-card success">
      <div class="stat-label">Completed</div>
      <div class="stat-value">{{ countByStatus('Completed') }}</div>
    </div>
    <div class="stat-card" *ngIf="userRole === 'StoreAdmin'">
      <div class="stat-label">Users</div>
      <div class="stat-value">{{ users.length }}</div>
    </div>
    <div class="stat-card" *ngIf="userRole === 'Admin'">
      <div class="stat-label">Stores</div>
      <div class="stat-value">{{ totalStores }}</div>
    </div>
  </div>

  <!-- Recent batches -->
  <div class="section-header">
    <h2 class="section-title">Recent Batches</h2>
    <a class="view-all-link" routerLink="/batchlist">View all</a>
  </div>

  <div class="dashboard-table-wrap">
    <table class="ss-table">
      <thead>
        <tr>
          <th>User</th>
          <th>Status</th>
          <th>Created</th>
          <th>Rx</th>
          <th>Meds</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let batch of recentBatches()" class="clickable" (click)="openBatch(batch)">
          <td>{{ batch.userName }}</td>
          <td>
            <span [ngClass]="getStatusClass(batch.status)" class="ss-status">{{ batch.status }}</span>
          </td>
          <td>{{ batch.createdAt | date: 'dd MMM, HH:mm' }}</td>
          <td>{{ batch.prescriptions.length }}</td>
          <td>{{ getMedicationCount(batch) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="ss-empty" *ngIf="batches.length === 0">No batches found.</div>
  </div>

</div>

<!-- In-progress side panel -->
<button class="panel-toggle" *ngIf="!showInProgressList && !loading" (click)="openNav()">
  In Progress ({{ countByStatus('InProgress') }})
</button>

<div class="inprogress-panel" [class.closed]="!showInProgressList">
  <div class="panel-header">
    <h3>In-Progress Batches</h3>
    <button class="panel-close" (click)="closeNav()">×</button>
  </div>
  <div class="panel-body">
    <div class="panel-batch-row clickable" *ngFor="let batch of getInProgressList()" (click)="openBatch(batch)">
      <div class="panel-batch-user">{{ batch.userName }}</div>
      <div class="panel-batch-meta">
        {{ batch.createdAt | date: 'dd MMM HH:mm' }} &mdash;
        {{ batch.prescriptions.length }} Rx, {{ getMedicationCount(batch) }} meds
      </div>
    </div>
    <div class="ss-empty" *ngIf="getInProgressList().length === 0">None in progress.</div>
  </div>
</div>
